import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * NoIndexSEO Component
 * Used for protected/authenticated pages that should NOT be indexed by search engines
 * This is a security best practice to prevent sensitive data from appearing in search results
 */
const NoIndexSEO = ({ title = 'Map My Pay' }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {/* Prevent search engines from indexing this page */}
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
      {/* Prevent caching */}
      <meta httpEquiv="cache-control" content="no-cache" />
      <meta httpEquiv="expires" content="0" />
      <meta httpEquiv="pragma" content="no-cache" />
    </Helmet>
  );
};

export default NoIndexSEO;
